import { X } from 'lucide-react';

import CreateBatchCall from '@/pages/BatchCall/BatchCallCreate/CreateBatchCall';

import { Button } from '@/components/ui/button';
import { Dialog, DialogContent } from '@/components/ui/dialog';

type BatchCallCreateDialogProps = {
  toggle: () => void;
};

export function BatchCallCreateDialog({ toggle }: BatchCallCreateDialogProps) {
  return (
    <Dialog open onOpenChange={toggle}>
      <DialogContent
        showCloseButton={false}
        className="!max-w-none !w-screen !h-screen p-0 border-0 bg-background flex items-center justify-center !fixed !inset-0 !translate-x-0 !translate-y-0 rounded-none !top-0 !left-0"
      >
        {/* Close button */}
        <Button
          variant="outline"
          size="icon"
          className="absolute top-5 right-5 h-9 w-9 rounded-full z-10"
          onClick={toggle}
        >
          <X className="h-[18px] w-[18px] opacity-70" />
        </Button>

        <CreateBatchCall onClose={toggle} />
      </DialogContent>
    </Dialog>
  );
}
